import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: window.location.hostname.split(".")[0],
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  loginRequired: true
});

export default keycloak;
